import { render, staticRenderFns } from "./SpellGroup.vue?vue&type=template&id=3c11dcd8&scoped=true"
import script from "./SpellGroup.vue?vue&type=script&lang=js"
export * from "./SpellGroup.vue?vue&type=script&lang=js"
import style0 from "./SpellGroup.vue?vue&type=style&index=0&id=3c11dcd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c11dcd8",
  null
  
)

export default component.exports